import { useMemo } from "react";
import { Box } from "@mui/material";
import { t } from "i18next";
import BaseTable from "../../components/table/BaseTable";
import SelectFieldService from "../../services/selectFieldService";
import { isEmptyArray } from "../../helpers/methods";

const HEADERS = [
    t("clients.PersonClausesDialog.table.clauses_type"),
    t("clients.PersonClausesDialog.table.persclau_decision"),
];

export function ActualPersonClausesTable(props) {
    const rowData = useMemo(()=>{
        const temporaryClauses = props.actualClauses?.filter((clause)=>clause.clause_is_temporary)
        const marketingClauses = props.actualClauses?.filter((clause)=>!clause.clause_is_temporary)
        
        return [
            {rowId: 1, data: [t("clients.PersonClausesDialog.table.marketing_clauses"), !isEmptyArray(marketingClauses || []) ? SelectFieldService.getLabelOptionsTrueOrFalse(marketingClauses.some(clause=>clause.persclau_decision)) : "-"]},
            {rowId: 2, data: [t("clients.PersonClausesDialog.table.temporary_clause"), !isEmptyArray(temporaryClauses || []) ? SelectFieldService.getLabelOptionsTrueOrFalse(temporaryClauses.some(clause=>clause.persclau_decision)) : "-"]},
        ]

    }, [props.actualClauses])

    
    return (
        <Box sx={{ maxHeight: 200, overflow: "auto", borderRadius: 1 }}>
            <BaseTable
                stickyHeader={false}
                headers={HEADERS}
                rows={rowData}
                showEditButton={false}
                showDeleteButton={false}
                sortable={false}
                hiddenColumns={[]}
                selectedRows={[]}
            />
        </Box>
    );
}
